class CategoryFormHelper {
  constructor() {
    this.bannerState = null;
  }
  setBannerState(state) {
    this.bannerState = state;
  }
  getBannerState() {
    return this.bannerState;
  }
}

export default new CategoryFormHelper();
